const colors = require("../../src/styles/colors");

module.exports = {
  siteTitle: "Keziyah's blog - Keziyah.com", // <title>
  shortSiteTitle: "Keziyah's Blog", // <title> ending for posts and pages
  siteDescription: "Keziyah's blog on life, tech, and being an indie maker. ",
  siteUrl: "https://blog.keziyah.com",
  pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",
  // author
  authorName: "Keziyah Lewis",
  authorTwitterAccount: "keziyahl",
  // info
  infoTitle: "Keziyah Lewis",
  infoTitleNote: "personal blog",
  // manifest.json
  manifestName: "Keziyah's blog - Keziyah.com",
  manifestShortName: "KeziyahsBlog", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.background,
  manifestThemeColor: colors.background,
  manifestDisplay: "standalone",
  // contact
  contactEmail: "hello@keziyah.com",
  // social
  authorSocialLinks: [
    { name: "github", url: "https://github.com/keziyah" },
    { name: "twitter", url: "https://twitter.com/keziyahl" },
    { name: "facebook", url: "https://facebook.com/keziyahlewis" }
  ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js